import { siteConfig } from '@/configs/siteConfig';

const props = {
  modalId: 'js-modal',
  overlayId: 'js-modalOverlay',

  htmlStateClass: 'is-modalOpen',
  openClass: 'js-modalOpen',
  closeClass: 'js-modalClose',

  delay: 300,
} as const;

const state = {
  modalEl: null as HTMLElement | null,
  overlayEl: null as HTMLElement | null,
  openStateEl: null as HTMLElement | null,
};

export const modalManager = {
  init() {
    state.modalEl = document.getElementById(props.modalId);
    state.overlayEl = document.getElementById(props.overlayId);

    if (state.modalEl) {
      this.setupClickOpen();
      this.setupClickClose();

      if (state.overlayEl) {
        this.setupClickOverlay();
      }
    }
  },

  setupClickOpen() {
    document.addEventListener('click', (e) => {
      const etarget = e.target as HTMLElement | null;
      const btnOpenEl = etarget?.closest(`.${props.openClass}`);
      if (!btnOpenEl) return;

      e.preventDefault();

      const targetModalSel = btnOpenEl.getAttribute('data-modal') || btnOpenEl.getAttribute('href');
      if (!targetModalSel) {
        console.warn('[modalManager] モーダルターゲットが指定されていません（data-modal または href が必要）', btnOpenEl);
        return;
      }

      const targetModalEl = document.querySelector(targetModalSel) as HTMLElement | null;
      if (!targetModalEl) {
        console.warn(`[modalManager] モーダルターゲット "${targetModalSel}" が見つかりません`, btnOpenEl);
        return;
      }

      if (state.openStateEl) {
        state.openStateEl.classList.remove(siteConfig.class.open);
        state.openStateEl = null;
      }

      this.modalOpen(targetModalEl);
    });
  },

  setupClickClose() {
    document.addEventListener('click', (e) => {
      const etarget = e.target as HTMLElement | null;
      const btnCloseEl = etarget?.closest(`.${props.closeClass}`);
      if (!btnCloseEl) return;

      this.modalClose();
      this.stopAllIframeYoutube();
    });
  },

  stopAllIframeYoutube() {
    const iframes = document.querySelectorAll('.c-modal iframe') as NodeListOf<HTMLIFrameElement>;

    iframes.forEach((iframe) => {
      if (!iframe.src.includes('youtube.com/embed')) return;

      iframe.contentWindow?.postMessage(
        JSON.stringify({
          event: 'command',
          func: 'pauseVideo',
          args: [],
        }),
        '*',
      );
    });
  },

  setupClickOverlay() {
    state.overlayEl!.addEventListener('click', () => {
      this.modalClose();
      this.stopAllIframeYoutube();
    });
  },

  modalOpen(targetEl: HTMLElement) {
    state.openStateEl = targetEl;
    state.modalEl!.style.display = 'block';
    targetEl.classList.add(siteConfig.class.open);
    requestAnimationFrame(() => {
      document.documentElement.classList.add(props.htmlStateClass);
    });
  },

  modalClose() {
    document.documentElement.classList.remove(props.htmlStateClass);
    setTimeout(() => {
      state.modalEl!.style.display = 'none';

      if (!state.openStateEl) return;
      state.openStateEl.classList.remove(siteConfig.class.open);
      state.openStateEl = null;
    }, props.delay);
  },
};

//
// ### SAMPLE HTML ###
//
// <a href="#xxx" class="js-modalOpen">OPENボタン</a>
// <div class="c-modal" id="js-modal">
//   <div class="c-modal__overlay" id="js-modalOverlay"></div>
//   <button class="c-modal__closeBtn js-modalClose"></button>
//   <div class="c-modal__inner">
//     <!-- ####  xxx  #### -->
//     <div class="c-modal__item" id="xxx">
//       <div class="c-modal__itemCloseBtnFrame">
//         <button class="c-modal__itemCloseBtn js-modalClose"></button>
//       </div>
//       <div class="c-modal__itemInner">
//         ## コンテンツ ##
//       </div>
//     </div>
//     <!-- ####  xxx END  #### -->
//   </div>
// </div>
//
